/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const VIDEOS = [
  {
    "src": "a/Pike-Crunch-bg-1024x1024-de1f0b.webp",
    "kinds": [
      "قدرتی"
    ],
    "tags": [
      "قدرتی"
    ],
    "name": "Stability Ball Pike Crunch",
    "chips": [
      "مناسب همه‌ی سطوح",
      "Stability Ball"
    ]
  },
  {
    "src": "a/BD-Kneeling-bg-8b8477.webp",
    "kinds": [
      "قدرتی",
      "فانکشنال"
    ],
    "tags": [
      "قدرتی",
      "فانکشنال"
    ],
    "name": "BD Kneeling Glute Kickback",
    "chips": [
      "مناسب همه‌ی سطوح",
      "کش"
    ]
  },
  {
    "src": "a/triceps-push-bg-1ea4f9.webp",
    "kinds": [
      "قدرتی"
    ],
    "tags": [
      "قدرتی"
    ],
    "name": "Stability Ball Pike Crunch",
    "chips": [
      "مناسب همه‌ی سطوح",
      "سیم‌کش"
    ]
  },
  {
    "src": "a/single-v-bg-2c24e3.webp",
    "kinds": [
      "قدرتی",
      "فانکشنال"
    ],
    "tags": [
      "قدرتی",
      "فانکشنال"
    ],
    "name": "Crunch Touch Knee & Toes",
    "chips": [
      "مناسب همه‌ی سطوح",
      "بدون وسیله"
    ]
  },
  {
    "src": "https://app.sequoia.fitness/assets/images/exercise-posters/4786.webp",
    "kinds": [
      "قدرتی"
    ],
    "tags": [
      "قدرتی"
    ],
    "name": "AB-wheel",
    "chips": [
      "مناسب همه‌ی سطوح",
      "ABS Wheel"
    ]
  },
  {
    "src": "https://app.sequoia.fitness/assets/images/exercise-posters/63.webp",
    "kinds": [
      "قدرتی"
    ],
    "tags": [
      "قدرتی"
    ],
    "name": "Band Pull-Aparts – overhead",
    "chips": [
      "متوسط",
      "کش"
    ]
  },
  {
    "src": "https://app.sequoia.fitness/assets/images/exercise-posters/61.webp",
    "kinds": [
      "قدرتی"
    ],
    "tags": [
      "قدرتی"
    ],
    "name": "Dead Hangs",
    "chips": [
      "متوسط",
      "بدون وسیله"
    ]
  },
  {
    "src": "https://app.sequoia.fitness/assets/images/exercise-posters/55.webp",
    "kinds": [
      "موبیلیتی"
    ],
    "tags": [
      "موبیلیتی"
    ],
    "name": "BD Wall Slides",
    "chips": [
      "مبتدی",
      "بدون وسیله"
    ]
  }
]

export const KIND_COLORS = {"قدرتی":"#fda4af","فانکشنال":"#a5b4fc","موبیلیتی":"#5eead4"}
